import {
  BaseUniDriver,
  baseUniDriverFactory,
  UniDriver,
} from '@wix/wix-ui-test-utils/unidriver';
import { ContentType } from './types';

export interface AvatarDriver extends BaseUniDriver {
  /** Get the currently displayed type. Types are: 'text', 'icon', 'image'. It could be that the resolved type is 'image' but the currently displayed one is `text`. */
  getContentType(): Promise<ContentType>;
  /** Get the text content (generated initials) */
  getTextContent(): Promise<string>;
  /** Wether the image wass loaded */
  isImageLoaded(): Promise<boolean>;
  src(): Promise<string>;
}

export const avatarDriverFactory = (base: UniDriver): AvatarDriver => {
  const getContentType = () =>
    base.attr('data-content-type') as Promise<ContentType>;

  return {
    ...baseUniDriverFactory(base),
    getContentType,
    getTextContent: () => base.attr('data-initials'),
    isImageLoaded: async () => (await base.attr('data-img-loaded')) === 'true',
    /**
     * Gets the src
     * @return {Promise<string>}
     */
    src: async () => {
      let src = '';

      try {
        src = await base.$('img').attr('src');
      } catch (e) {}

      return src;
    },
  };
};
